import {Button} from "@mui/material"
import Grid from "@mui/material/Grid"
import {RedCrossIcon, ReoccurringDollarIcon} from "@indebted/assets"
import {paletteColors} from "@indebted/theme"
import {useNavigate} from "react-router-dom"

import {nextPage} from "../Navigator"

import {ColoredTypographyWithBottomMargin} from "./styles"

const PaymentFailedPage = ({
	paymentArrangementID,
	I18n,
	Next,
	FailureReason,
}: {
	paymentArrangementID: string
	I18n: {
		Title: string
		Subtitle: string
		ReasonLabel: string
		ButtonText: string
	}
	Next: string
	FailureReason: string
}) => {
	const navigate = useNavigate()
	return (
		<Grid container direction="column" alignItems="center" justifyContent="center">
			<Grid container direction="row" alignItems="center" justifyContent="center" style={{marginTop: "25px"}}>
				<RedCrossIcon />
			</Grid>
			<Grid container direction="row" alignItems="center" justifyContent="center" style={{marginBottom: "10px"}}>
				<ColoredTypographyWithBottomMargin
					variant="h5"
					color={paletteColors.stratosLight2}
					align="center"
					style={{padding: "0 30px", fontWeight: 700, lineHeight: "28px"}}
				>
					{I18n.Title}
				</ColoredTypographyWithBottomMargin>
			</Grid>

			<Grid container direction="row" alignItems="center" justifyContent="center" style={{marginBottom: "10px"}}>
				{FailureReason && (
					<ColoredTypographyWithBottomMargin
						variant="subtitle1"
						color={paletteColors.stratos}
						align="center"
						style={{padding: "0 30px", lineHeight: "22px", fontSize: 16}}
					>
						{I18n.ReasonLabel}: {FailureReason}
					</ColoredTypographyWithBottomMargin>
				)}
			</Grid>

			<Grid container direction="row" alignItems="center" justifyContent="center" style={{marginBottom: "34px"}}>
				<ColoredTypographyWithBottomMargin
					variant="subtitle1"
					color={paletteColors.stratos}
					align="center"
					style={{padding: "0 64px", lineHeight: "16px", fontSize: 14}}
				>
					{I18n.Subtitle}
				</ColoredTypographyWithBottomMargin>
			</Grid>

			<Button
				style={{borderRadius: "35px", padding: "6px 30px", marginTop: "10px"}}
				type="button"
				onClick={() => navigate(nextPage(Next, paymentArrangementID))}
				variant="contained"
				startIcon={<ReoccurringDollarIcon />}
			>
				{I18n.ButtonText}
			</Button>
		</Grid>
	)
}

export {PaymentFailedPage}
